export default "__VITE_ASSET__I25lmiS2__"